import { axiosInstance } from "./BaseService" 

export const fetchStoresRegionNameAndId = async () => {
  try {
    const response = await axiosInstance.get('/stores/regions');
    return response.data;
  } catch (err) {
    throw err;
  }
}